import { useState, useCallback } from 'react';

/**
 * Hook para manejar alertas de éxito (BottomAlert)
 * @param {number} duration - Duración en milisegundos (default: 3000)
 * @returns {Object} - { showAlert, alertProps, triggerAlert }
 */
const useSuccessAlert = (duration = 3000) => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    message: '',
    type: 'success',
    icon: 'check-circle',
  });

  const triggerAlert = useCallback(
    (message, options = {}) => {
      const { type = 'success', icon = 'check-circle', duration: customDuration } = options;

      setAlertState({
        isOpen: true,
        message,
        type,
        icon,
      });

      setTimeout(() => {
        setAlertState((prev) => ({ ...prev, isOpen: false }));
      }, customDuration || duration);
    },
    [duration]
  );

  return {
    showAlert: alertState.isOpen,
    alertProps: alertState,
    triggerAlert,
  };
};

export default useSuccessAlert;

